import { type Dispatch, type SetStateAction, useState } from 'react'

import { type OpenableControls } from '../../generic-hooks'

export const useDirectContactFormWhenCustomerSupportIsUnavailable = ({
  onCustomerSupportUnavailableFormSubmittedWithSuccess,
}: {
  modalControls: OpenableControls
  onCustomerSupportUnavailableFormSubmittedWithSuccess: Dispatch<
    SetStateAction<boolean>
  >
}): {
  handleContactFormClick: () => void
  handleContactFormClose: () => void
  handleSuccess: () => void
  hasCustomerClickedContactForm: boolean
} => {
  const [hasCustomerClickedContactForm, setHasCustomerClickedContactForm] =
    useState(false)

  const handleSuccess = (): void => {
    onCustomerSupportUnavailableFormSubmittedWithSuccess(true)
  }

  const handleContactFormClick = (): void => {
    setHasCustomerClickedContactForm(true)
  }

  const handleContactFormClose = (): void => {
    setHasCustomerClickedContactForm(false)
  }

  return {
    handleContactFormClick,
    handleContactFormClose,
    handleSuccess,
    hasCustomerClickedContactForm,
  }
}
